import { connect } from 'react-redux'
import { selectCurrentSearchQueryTotalCount } from 'ducks/searches/selectors'
import CountView from 'components/ConversationList/Header/TitleBar/Count'

const select = state => ({
  count: selectCurrentSearchQueryTotalCount(state),
})

export default connect(select)(CountView)
